function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { MenuItem, TextField, Tooltip, Typography, useStateInRef } from 'seagull';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import { getBillingTriggerOptions } from "./ServiceBuilder.utils";
import { serviceModel } from "../../../models";
export default function BillingTriggerDropdown(props) {
  const {
    serviceOrigin,
    service
  } = props;
  const getProps = useStateInRef(props);
  const {
    control,
    watch,
    getValues,
    setValue
  } = useFormContext();
  const [recurrencePeriod, pricing] = watch(['recurrencePeriod', 'pricing']);
  const [triggerDropdownRef, setTriggerDropdownRef] = useState(null);
  const [options, setOptions] = useState(() => getBillingTriggerOptions(getValues(), serviceOrigin, !!service));
  const isApprovedServiceInAgreement = !!(serviceOrigin === 'agreement' && service && !serviceModel.isAwaitingApproval(service.status));
  useEffect(() => {
    const {
      service,
      serviceOrigin
    } = getProps();
    const newOptions = getBillingTriggerOptions(getValues(), serviceOrigin, !!service);
    setOptions(newOptions);

    if (newOptions.every(opt => opt.value !== getValues().trigger)) {
      setValue('trigger', newOptions[0].value);
    }
  }, [pricing, recurrencePeriod]);
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "trigger",
    render: renderProps => /*#__PURE__*/React.createElement(Tooltip, {
      title: isApprovedServiceInAgreement ? 'Billing trigger cannot be modified; to modify a trigger, create a new service and add it to the agreement.' : ''
    }, /*#__PURE__*/React.createElement(TextField, _extends({
      select: true,
      ref: setTriggerDropdownRef
    }, connectControllerToTextField(renderProps), {
      disabled: isApprovedServiceInAgreement,
      label: "Billing trigger",
      "data-testid": "sb-trigger",
      SelectProps: {
        renderValue: value => {
          const selected = options.find(opt => opt.value === value);
          return selected ? selected.text : '';
        }
      }
    }), options.map((_ref, idx) => {
      let {
        value,
        text,
        subtext
      } = _ref;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: value,
        value: value,
        variant: "multiline",
        "data-testid": "sb-trigger-opt-".concat(idx),
        style: {
          width: triggerDropdownRef === null || triggerDropdownRef === void 0 ? void 0 : triggerDropdownRef.clientWidth
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        weight: "normal"
      }, text), /*#__PURE__*/React.createElement(Typography, null, subtext));
    })))
  });
}